import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-payment-term',
  templateUrl: './modify-payment-term.component.html',
  styleUrls: ['./modify-payment-term.component.css']
})
export class ModifyPaymentTermComponent implements OnInit {

  cid: any;
  paymentTermData: any = []
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  singlePaymentTermData: any = []
  isEdit = false;
  paymentTermForm: any | FormGroup;
  
  termTypes = [
    { value: 'HOUR', viewValue: 'Hour' },
    { value: 'DAY', viewValue: 'Day' },
    { value: 'WEEK', viewValue: 'Week' },
    { value: 'MONTH', viewValue: 'Month' },
  ];
  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllPaymentTerm()


    this.paymentTermForm = this.fb.group({
      termName: ['',[Validators.required]],
      termValue: ['',[Validators.required]],
      termType: ['',[Validators.required]],
    });
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllPaymentTerm();
  }
  
  onTableSizeChange(event: any): void {
    this.pageNumber = event;
    this.getAllPaymentTerm();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton4")?.click()
  }

  getAllPaymentTerm(){
    this.generic_service.getAllPaymentTerm().subscribe(
      (response:any)=> {
        console.log(response)
        this.paymentTermData = response.response
        this.totalRecords = response.response.length

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getPaymentTermById(paymentTermId:any){
    
    this.generic_service.getPaymentTermById(paymentTermId).subscribe(
      (response:any)=>{
        console.log(response)
        this.singlePaymentTermData = []
        this.singlePaymentTermData.push(response.response)
        this.paymentTermForm.setValue(
          {
            termName: response.response.termName,
            termValue: response.response.termValue,
            termType: response.response.termType
          }
        );
        this.isEdit = true;

      },
      (err:any)=> {
        console.log(err)
      }
    )
  }


  editPaymentTerm(){

    if(!this.paymentTermForm.valid){
      this.toastr.error('please fill required fields');

      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": this.singlePaymentTermData[0].id,
      "paymentTermId": this.singlePaymentTermData[0].paymentTermId,
      "termName": this.paymentTermForm.get('termName').value,
      "termValue": this.paymentTermForm.get('termValue').value,
      "termType": this.paymentTermForm.get('termType').value,
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.editPaymentTerm(body).subscribe(
      (response:any) => {
        console.log(response)
        this.paymentTermForm.reset()
        this.getAllPaymentTerm()
        this.closeEdit()
      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )

  }


  closeEdit() {
    this.isEdit = false;
    this.paymentTermForm.reset()
  }
 
}
